import React from "react"
import { RadioBox } from "../helper";
import { Translate } from "react-localize-redux";

export class ProtectorType extends RadioBox {
	constructor(props) {
		super(props, props.setState)
	}
	render() {
		return (
			<Translate key={this.props.template.id}>
				{({ translate }) => 
					<div className="oc-form-group-wrapper">
						<h6>{ this.props.template.name }</h6>
                        <ul>
                            <li>
                                <label
                                    className={`
                                        oc-form-label
                                        ${this.state.value === 'สำลี' ? 'active': ''}
                                    `.trim()}
                                >
                                    {translate('form_audio_protector_type_cotton')}
                                    <input
                                        name={`${this.props.template.id}`}
                                        type="radio"
                                        value="สำลี"
                                        checked={this.state.value === 'สำลี'}
                                        onChange={(e) => this.onChangeHandler(e)}
                                    />
                                </label>
                            </li>
                            <li>
                                <label
                                    className={`
                                        oc-form-label
                                        ${this.state.value === 'ปลั๊กอุดหู' ? 'active': ''}
                                    `.trim()}
                                >
                                    {translate('form_audio_protector_type_plug')}
                                    <input
                                        name={`${this.props.template.id}`}
                                        type="radio"
                                        value="ปลั๊กอุดหู"
                                        checked={this.state.value === 'ปลั๊กอุดหู'}
                                        onChange={(e) => this.onChangeHandler(e)}
                                    />
                                </label>
                            </li>
                            <li>
                                <label
                                    className={`
                                        oc-form-label
                                        ${this.state.value === 'ที่ครอบหู' ? 'active': ''}
                                    `.trim()}
                                >
                                    {translate('form_audio_protector_type_muffs')}
                                    <input
                                        name={`${this.props.template.id}`}
                                        type="radio"
                                        value="ที่ครอบหู"
                                        checked={this.state.value === 'ที่ครอบหู'}
                                        onChange={(e) => this.onChangeHandler(e)}
                                    />
                                </label>
                            </li>
                        </ul>
					</div>
				}
			</Translate>
		)
	}
}